import React, { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion'; 

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CoursePlayerView from './components/CoursePlayerView'; 
import AuthModal from './components/AuthModal';
import HeroCarousel from './components/HeroCarousel'; 
import CategoryPills from './components/CategoryPills';
import Benefits from './sections/Benefits';
import LearningGrid from './sections/LearningGrid';
import Testimonials from './sections/Testimonials';
import Row from './components/Row';
import FAQ from './sections/FAQ';
import RevealOnScroll from './components/RevealOnScroll';
import { coursesData } from './data/courses';

function App() {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isAuthOpen, setIsAuthOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); 
  const [activeCategory, setActiveCategory] = useState("");

  useEffect(() => {
    document.documentElement.classList.add('dark');
    document.body.style.backgroundColor = '#050505';
  }, []);

  const handleOpenAuth = () => setIsAuthOpen(true);

  
  const filteredCourses = coursesData.filter(course => {
    const query = searchQuery.toLowerCase();
    const matchesSearch = 
      course.title.toLowerCase().includes(query) || 
      course.instructor.toLowerCase().includes(query);
    const matchesCategory = activeCategory === "" || course.category === activeCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="bg-[#050505] min-h-screen text-slate-100 selection:bg-blue-500/30">
      
      <Navbar onOpenAuth={handleOpenAuth} onSearch={setSearchQuery} />
      
      <main>
        
        <section id="hero">
          <HeroCarousel courses={coursesData.filter(c => c.featured)} onPlay={setSelectedCourse} />
        </section>

      
        <CategoryPills 
            selected={activeCategory} 
            onSelect={(cat) => {
                setActiveCategory(cat);
                if(cat !== "") setSearchQuery("");
            }} 
        />

        <div className="container mx-auto px-4 pb-20 space-y-24"> 
          {searchQuery || activeCategory ? (
             <div className="pt-10 min-h-[60vh]">
                <Row 
                  title={searchQuery ? `Resultados para "${searchQuery}"` : activeCategory} 
                  courses={filteredCourses} 
                  onPlay={setSelectedCourse} 
                />
             </div>
          ) : (
            <>
              
              <div id="beneficios">
                <RevealOnScroll><Benefits /></RevealOnScroll>
              </div>

              
              <div id="rutas" className="space-y-24">
                <Row title="Frontend mastery" courses={coursesData.filter(c => c.category === 'Frontend')} onPlay={setSelectedCourse} />
                <Row title="Inteligencia Artificial" courses={coursesData.filter(c => c.category === 'Data Science')} onPlay={setSelectedCourse} />
              </div>
              
              
              <div id="interese" className="pt-12 space-y-8">
                <div className="px-2">
                   <h2 className="text-3xl font-black text-white tracking-tighter uppercase italic">
                     Quizás te <span className="text-blue-500">interese</span>
                   </h2>
                </div>
                
                <HeroCarousel 
                  courses={coursesData.filter(c => c.rating >= 4.9)} 
                  onPlay={setSelectedCourse} 
                />
              </div>
            </>
          )}
        </div>
        
        
        <div id="tecnologias"> 
          <LearningGrid /> 
        </div>
        
        
        <div id="opiniones"> 
          <RevealOnScroll>
            <Testimonials /> 
          </RevealOnScroll>
        </div>
        <div id="faq"> <FAQ /> </div>
      </main>



      <Footer />

      <AnimatePresence>
        {selectedCourse && (
          <CoursePlayerView 
            course={selectedCourse} 
            onClose={() => setSelectedCourse(null)} 
          />
        )}
      </AnimatePresence>

      <AuthModal isOpen={isAuthOpen} onClose={() => setIsAuthOpen(false)} isDarkMode={true} />

    </div>
  );
}

export default App;